import { Component, inject, OnDestroy, Output, EventEmitter, ViewChild  } from '@angular/core';
import { RouterModule, Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatSidenavModule, MatDrawer } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MediaMatcher } from '@angular/cdk/layout';
import { SitenavContent } from '../sitenav-content/sitenav-content';

@Component({
  selector: 'app-sitenav',
  imports: [
    RouterModule,
    CommonModule,
    RouterOutlet,
    MatListModule,
    MatSidenavModule,
    SitenavContent,
  ],
  templateUrl: './sitenav.component.html',
  styleUrl: './sitenav.component.scss',
})
export class SitenavComponent implements OnDestroy {
  router = inject(Router);
  @Output() toggleMobileMenu = new EventEmitter<void>();
  @ViewChild('snavMobile') snavMobile!: MatDrawer;

  
  constructor() {
    const media = inject(MediaMatcher);
  }

  toggleMobile() {
    if (this.snavMobile) {
      this.snavMobile.toggle();
    }
  }

  ngOnDestroy(): void {
  }


}
